import { Product } from '../../lib/types/models/product/product'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getProduct(id: number) {
  return restApiClient.url(constructApiUrl(API.products.get.url, { id })).get<Product>()
}
